var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgListAlt = function SvgListAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "list_alt_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#list_alt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.073 20.962q.47 0 .788-.319.317-.317.317-.788 0-.47-.318-.788a1.07 1.07 0 0 0-.789-.317q-.47 0-.787.318a1.07 1.07 0 0 0-.318.789q0 .47.318.787.319.318.789.318m0-4.856q.47 0 .788-.319.317-.317.317-.788 0-.47-.318-.787a1.07 1.07 0 0 0-.789-.318q-.47 0-.787.319a1.07 1.07 0 0 0-.318.788q0 .47.318.787.319.318.789.318m0-4.856q.47 0 .788-.318.317-.318.317-.789 0-.47-.318-.787a1.07 1.07 0 0 0-.789-.318q-.47 0-.787.319a1.07 1.07 0 0 0-.318.788q0 .47.318.788.319.317.789.317m4.735 9.543h5.24q.399 0 .668-.27.27-.27.27-.668a.9.9 0 0 0-.27-.668.9.9 0 0 0-.668-.269h-5.24a.9.9 0 0 0-.668.27.9.9 0 0 0-.27.668q0 .399.27.668.27.27.668.27m0-4.855h5.24q.399 0 .668-.27.27-.27.27-.668a.9.9 0 0 0-.27-.668.9.9 0 0 0-.668-.27h-5.24a.9.9 0 0 0-.668.27.9.9 0 0 0-.27.668q0 .4.27.668.27.27.668.27m0-4.856h5.24q.399 0 .668-.27.27-.27.27-.668a.9.9 0 0 0-.27-.668.9.9 0 0 0-.668-.27h-5.24a.9.9 0 0 0-.668.27.9.9 0 0 0-.27.669q0 .398.27.668.27.269.668.269M6.635 25.625a2.18 2.18 0 0 1-1.604-.656 2.18 2.18 0 0 1-.656-1.604V6.635q0-.948.656-1.604a2.18 2.18 0 0 1 1.604-.656h16.73q.948 0 1.604.656t.656 1.604v16.73q0 .948-.656 1.604a2.18 2.18 0 0 1-1.604.656z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgListAlt);
export default ForwardRef;